export default "__VITE_ASSET__0f0499e4__"